import { captureException } from 'modules/sentry';
const sagaCatch = async (err) => {
  try {
    if (err && err.response && err.response.json) {
      const { url, status } = err.response;
      const body = await err.response.json();
      console.error('Uncaught request in saga', { url, body, status });
      throw new Error(`Uncaught request in saga ${url}`);
    }

    captureException(err);
  } catch (error) {
    captureException(error);
  }
};

export { sagaCatch };
